import { apiClient } from '@/lib/api';
import { ENDPOINTS } from '@/lib/api/endpoints';
import { Approval, ApprovalStats } from '../types/approval.types';

/**
 * Servicio para aprobaciones
 */
class ApprovalService {
  async getApprovals(): Promise<Approval[]> {
    return apiClient.get<Approval[]>(ENDPOINTS.APPROVALS);
  }

  async getApproval(id: string): Promise<Approval> {
    return apiClient.get<Approval>(`${ENDPOINTS.APPROVALS}/${id}`);
  }

  async approveQuote(approvalId: string, comments?: string): Promise<Approval> {
    return apiClient.post<Approval>(`${ENDPOINTS.APPROVALS}/${approvalId}/approve`, {
      comments,
    });
  }

  async rejectQuote(approvalId: string, comments: string): Promise<Approval> {
    return apiClient.post<Approval>(`${ENDPOINTS.APPROVALS}/${approvalId}/reject`, {
      comments,
    });
  }

  async requestAdjustment(
    approvalId: string,
    suggestedPrice: number,
    comments: string
  ): Promise<Approval> {
    return apiClient.post<Approval>(`${ENDPOINTS.APPROVALS}/${approvalId}/adjust`, {
      suggestedPrice,
      comments,
    });
  }

  async getStats(): Promise<ApprovalStats> {
    return apiClient.get<ApprovalStats>(`${ENDPOINTS.APPROVALS}/stats`);
  }
}

export const approvalService = new ApprovalService();
export default approvalService;
